$(document).ready(function () {
  if ($('.main-image').length && $('.thumbnail-image').length) {
    $('.main-image').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      asNavFor: '.thumbnail-image'
    });

    $('.thumbnail-image').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      asNavFor: '.main-image'
    });
  }
});
